import script from "./QModalWasteAddCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalWasteAddCategory.vue?vue&type=script&setup=true&lang=js"

import "./QModalWasteAddCategory.vue?vue&type=style&index=0&id=7ebf35b4&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ebf35b4"]])

export default __exports__